module.exports = __webpack_public_path__ + "img/banner-right-1920.fd8a75e0.png";